type LevelConnectorProps = React.SVGProps<SVGSVGElement> & ComponentStyling;

export const TreeLevelConnector = ({
  className,
  style,
  ...rest
}: LevelConnectorProps) => {
  return (
    <svg
      viewBox="0 0 38 22"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path
        d="M2 2V2C2 4.08647 3.3449 5.93511 5.33006 6.57737L31.8469 15.1564C34.3227 15.9573 36 18.2629 36 20.865V22"
        strokeLinecap="square"
        fill="none"
      />
    </svg>
  );
};
